import * as getters from '@/store/modules/payments/services/getters'
import * as mutations from '@/store/modules/payments/services/mutations'
import * as actions from '@/store/modules/payments/services/actions'

const state = {
    paymentsOperatorsList: [],
    parsedPaymentsOperatorsListNames: [],
    favoritesList: [],
    favoritesTabs: [],
    favoritesHasMore: null,
    paymentDetail: {},
    paymentsList: [],
    frequentOperations: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
